/* eslint-disable react/jsx-props-no-spreading */
import Button from '../../atoms/button';
import ImageTeaser from '../imageTeaser';
import { Heading } from '../../typography/heading/Heading';
import styles from './MediaSection.module.scss';
import React from 'react';
import { useMedia } from 'react-use';
import { StylesCustomizer } from '../../molecules/stylesCustomizer';
import clsx from 'clsx';

import { useInView } from 'react-intersection-observer';

const MediaSection = ({ data }) => {
  const {
    gridLayoutType = 'seamless',
    teasers,
    overlayTheme,
    showOverlay,
    desktopHeight,
    mobileHeight,
    tabletHeight,
    teasersLayoutType = 'transprentOverlay',
    mediaSectionHeader,
    mediaSectionHeaderStyles,
    showVideoControls,
  } = data;

  if (!teasers || !Array.from(teasers).length) return null;

  const isMobile = useMedia('(max-width: 680px)', false);

  const { ref: mediaRef, inView } = useInView();

  const trimText = (text) => text?.trim();

  const HeadingText = (variables) => {
    if (!mediaSectionHeader || !mediaSectionHeader?.trim()) return null;
    return (
      <Heading
        align="center"
        className={styles.mediaSectionHeader}
        as="h3"
        styleAs="h1"
        placement="plp"
        textTransform="capitalize"
        weight="normal"
        variables={variables}
      >
        <span dangerouslySetInnerHTML={{ __html: mediaSectionHeader }} />
      </Heading>
    );
  };
  const StyledHeadingText = StylesCustomizer(HeadingText);

  return (
    <div className={styles.mediaSection} ref={mediaRef}>
      {mediaSectionHeader && <StyledHeadingText styles={mediaSectionHeaderStyles} />}
      <div className={clsx(styles[gridLayoutType ? `gridLayout_${gridLayoutType}` : `gridLayout_seamless`])}>
        {teasers
          ? Array.from(teasers).map((teaser, index) => {
              const mergedVideoMobile = teaser.videoUrlMobile || teaser.videoUrl;
              const mergedImageMobile = teaser.imageMobile || teaser.image;
              const isLinkCovered = teaser?.button?.find((btn) => !!btn.isLinkCovered);

              return (
                <ImageTeaser
                  key={index}
                  isMobile={isMobile}
                  image={teaser.image}
                  isMain={teaser.isMobileMain}
                  label={trimText(teaser.label)}
                  labelStyles={teaser.labelStyles}
                  title={trimText(teaser.title)}
                  titleStyles={teaser.titleStyles}
                  subtitle={trimText(teaser.subTitle)}
                  subTitleStyles={teaser.subTitleStyles}
                  accentText={teaser.isAccent}
                  heightStyles={{
                    '--desktop-height': desktopHeight + '%',
                    '--mobile-height': mobileHeight ? mobileHeight + '%' : desktopHeight + '%',
                    '--tablet-height': tabletHeight ? tabletHeight + '%' : desktopHeight + '%',
                  }}
                  spacing={teaser.spacing}
                  button={
                    teaser?.button?.length
                      ? teaser?.button.map((item, index) => {
                          if (!item?.buttonTitle) {
                            return null;
                          }
                          return (
                            <Button
                              key={index}
                              shape="square"
                              variant={item.buttonType}
                              as={isLinkCovered?.isLinkCovered ? 'button' : 'link'}
                              nodeLink={isLinkCovered?.isLinkCovered ? null : item.buttonUrl}
                              ariaLabel={`media_section_${item.buttonTitle}`}
                              className={clsx(styles.imageTeaser_button, styles[item.buttonType])}
                              onClick={(event) => event.stopPropagation()}
                            >
                              {item.buttonTitle}
                            </Button>
                          );
                        })
                      : null
                  }
                  background={teaser.backgroundColor}
                  verticalPosition={teaser.verticalPosition}
                  horizontalPosition={teaser.horizontalPosition}
                  textAlign={teaser.titleAlignment}
                  hideImageOnMobile={teaser.isMobileBackgroundOnly}
                  isOverlay={showOverlay}
                  overlayTheme={overlayTheme}
                  imageMobile={mergedImageMobile}
                  videoUrl={teaser.videoUrl}
                  videoUrlMobile={mergedVideoMobile}
                  layoutType={teasersLayoutType}
                  link={isLinkCovered?.buttonUrl ?? null}
                  isLinkCovered={!!isLinkCovered}
                  mediaLoading={inView ? 'eager' : 'lazy'}
                  showVideoControls={showVideoControls}
                />
              );
            })
          : null}
      </div>
    </div>
  );
};

export default MediaSection;
